export default "__VITE_ASSET__BuI015Da__"